import React, { useState } from "react";
import { KeyboardArrowDown } from "@mui/icons-material";

const CourseRegistrationCard = () => {
  const [selectedLocation, setSelectedLocation] = useState("Århus");
  const [selectedDate, setSelectedDate] = useState("21 Jun - 20 Juli 2025");

  const locations = ["Århus", "København", "Online"];
  const dates = [
    "21 Jun - 20 Juli 2025",
    "15 Aug - 14 Sep 2025",
    "10 Okt - 9 Nov 2025",
  ];

  return (
    <div
      className="regis-card-bg"
      style={{
        backgroundColor: "#ffffff",
        padding: "20px",
        paddingTop: 0,
      }}
    >
      <div
        style={{
          padding: "32px",
          margin: "0 auto",
        }}
      >
        {/* Header */}
        <div style={{ marginBottom: "32px" }}>
          <h1
            style={{
              fontSize: "20px",
              fontWeight: "700",
              color: "#09366B",
              marginBottom: "12px",
            }}
          >
            Tilmelding
          </h1>
          <p
            style={{
              fontSize: "15px",
              color: "#09366B",
              lineHeight: "1.6",
            }}
          >
            Udfyld nedenstående oplysninger for at tilmelde dig et kursus med
            fysisk fremmøde. Husk, at undervisningen vil være tilgængelig online
            bagefter.
          </p>
        </div>

        {/* Course Details Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: "32px",
            marginBottom: "32px",
          }}
        >
          {/* Location */}
          <div>
            <label
              style={{
                display: "block",
                fontSize: "14px",
                fontWeight: "600",
                color: "#09366B",
                marginBottom: "8px",
              }}
            >
              Lokation
            </label>
            <div style={{ position: "relative" }}>
              <select
                value={selectedLocation}
                onChange={(e) => setSelectedLocation(e.target.value)}
                style={{
                  width: "100%",
                  background: "#E7EBF0",
                  border: "none",
                  opacity: "80%",
                  borderRadius: "8px",
                  padding: "12px 40px 12px 16px",
                  fontSize: "14px",
                  color: "#495057",
                  cursor: "pointer",
                  appearance: "none",
                  outline: "none",
                }}
              >
                {locations.map((location) => (
                  <option key={location} value={location}>
                    {location}
                  </option>
                ))}
              </select>
              <div
                style={{
                  position: "absolute",
                  right: "16px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  fontSize: "12px",
                  color: "#09366B",
                }}
              >
                <KeyboardArrowDown />
              </div>
            </div>
          </div>

          {/* Date */}
          <div>
            <label
              style={{
                display: "block",
                fontSize: "14px",
                fontWeight: "600",
                color: "#09366B",
                marginBottom: "8px",
              }}
            >
              Vælg startdato
            </label>
            <div style={{ position: "relative" }}>
              <select
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
                style={{
                  width: "100%",
                  background: "#E7EBF0",
                  border: "none",
                  opacity: "80%",
                  borderRadius: "8px",
                  padding: "12px 40px 12px 16px",
                  fontSize: "14px",
                  color: "#495057",
                  cursor: "pointer",
                  appearance: "none",
                  outline: "none",
                }}
              >
                {dates.map((date) => (
                  <option key={date} value={date}>
                    {date}
                  </option>
                ))}
              </select>
              <div
                style={{
                  position: "absolute",
                  right: "16px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  fontSize: "12px",
                  color: "#09366B",
                }}
              >
                <KeyboardArrowDown />
              </div>
            </div>
          </div>

          {/* Empty space for alignment */}
          <div></div>
        </div>

        {/* Reserve Button */}
        <div style={{ marginBottom: "32px" }}>
          <button
            className="btn-education-bg"
            style={{
              backgroundColor: "#1A3864",
              color: "white",
              border: "none",
              padding: "14px 24px",
              fontSize: "15px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "background-color 0.2s ease",
              outline: "none",
              opacity: "80%",
            }}
            onMouseEnter={(e) => (e.target.style.opacity = "100%")}
            onMouseLeave={(e) => (e.target.style.opacity = "80%")}
          >
            Reservér min plads
          </button>
        </div>

        {/* Course Info Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: "24px",
            paddingTop: "24px",
            borderTop: "1px solid #e9ecef",
          }}
        >
          <div>
            <h3
              style={{
                fontSize: "14px",
                fontWeight: "600",
                color: "#09366B",
                marginBottom: "4px",
              }}
            >
              Varighed
            </h3>
            <p
              style={{
                fontSize: "14px",
                color: "#09366B",
              }}
            >
              4 uger
            </p>
          </div>

          <div>
            <h3
              style={{
                fontSize: "14px",
                fontWeight: "600",
                color: "#09366B",
                marginBottom: "4px",
              }}
            >
              Støtteberettiget
            </h3>
            <p
              style={{
                fontSize: "14px",
                color: "#09366B",
              }}
            >
              Omstillingsfonden, VEØ/AMU
            </p>
          </div>

          <div>
            <h3
              style={{
                fontSize: "14px",
                fontWeight: "600",
                color: "#09366B",
                marginBottom: "4px",
              }}
            >
              Pris
            </h3>
            <p
              style={{
                fontSize: "14px",
                color: "#09366B",
              }}
            >
              9500 (eksl. moms)
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseRegistrationCard;
